import UpdateRetailer from "../../../../components/@users/retailers/UpdateRetailer";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function RetailerUpdatePage() {

    return (
        <UpdateRetailer 
            routeType={routeTypes.admin}
        />
    )
}       